import { Link } from "react-router-dom";

export default function Test() {
    const seriesId = "65c243a05ef928b3bf9b75d5"
    const videoId = "65c243a05ef928b3bf9b75d5"
    return (
        <>
            <Link to={`/watch?series=${seriesId}&video=${videoId}`} >go</Link>
        </>
    );
}
